import { useEffect, useState } from "react";
import SetupProgress from "../components/SetupProgress";
import Password from "../components/Password";
import Address from "../components/Address";
import StoreOperation from "../components/StoreOperation";
import StoreOperationMore from "../components/StoreOperationMore";
import VerifyId from "../components/VerifyId";
import StripeSetup from "../components/StripeSetup";
import ProgressStepDocuments from "../components/ProgressStepDocuments";
import useFetchOnboardingStatus from "../../../utils/hooks/useFetchOnboardingStatus";
import Subscriptions from "../components/Subscription";

const AccountSetup = () => {
  const stepNumber = useFetchOnboardingStatus();
  const [step, setStep] = useState();

  useEffect(() => {
    if (stepNumber !== null) {
      setStep(stepNumber);
    }
  }, [stepNumber]);

  return (
    <div className="account-setup">
      <SetupProgress step={step} />
      {step === 1 && <Password setStep={setStep} />}
      {step === 2 && <Address setStep={setStep} />}
      {step === 3 && <StoreOperation setStep={setStep} />}
      {step === 4 && <StoreOperationMore setStep={setStep} />}
      {step === 5 && <VerifyId setStep={setStep} />}
      {step === 6 && <Subscriptions setStep={setStep} />}
      {step === 7 && <StripeSetup setStep={setStep} />}
      {step === 8 && <ProgressStepDocuments setStep={setStep} />}
    </div>
  );
};

export default AccountSetup;
